const wrapper = "cui-tablist-wrapper-p7kr";
const base = "cui-tablist-xfbs";
const stretched = "cui-tablist-stretched-tmnx";
const classes = {
  wrapper,
  base,
  stretched,
  "stretched-mobile": "cui-tablist-stretched-mobile-jmnf"
};
export {
  base,
  classes as default,
  stretched,
  wrapper
};
